import type { StoryPreferences } from "./story-memory.js";
const same = (a: unknown, b: unknown): boolean => JSON.stringify(a) === JSON.stringify(b);
export const preferenceContent = ({ threads, lessons, genreIds, genreNotes, semanticRetrieval }: StoryPreferences) => ({ threads, lessons, genreIds, genreNotes, semanticRetrieval: Boolean(semanticRetrieval) });
/** Three-way merge for an explicit UI action. Conflicts keep local text, never auto-save. */
export function mergeStoryPreferences(base: StoryPreferences, local: StoryPreferences, remote: StoryPreferences): { value: StoryPreferences; conflicts: string[] } {
  const conflicts: string[] = [];
  function choose<T>(key: string, before: T, ours: T, theirs: T): T {
    if (same(ours, before)) return theirs;
    if (same(theirs, before) || same(ours, theirs)) return ours;
    conflicts.push(key); return ours;
  }
  function mergeItems<T>(name: string, previous: T[], ours: T[], theirs: T[], key: (item: T) => string): T[] {
    const b = new Map(previous.map(item => [key(item), item])); const l = new Map(ours.map(item => [key(item), item])); const r = new Map(theirs.map(item => [key(item), item]));
    return [...new Set([...r.keys(), ...l.keys(), ...b.keys()])].flatMap(id => {
      const selected = choose(`${name}/${id}`, b.get(id), l.get(id), r.get(id)); return selected === undefined ? [] : [selected];
    });
  }
  return { value: { ...remote,
    threads: mergeItems("线索计划", base.threads, local.threads, remote.threads, item => item.key),
    lessons: mergeItems("作者经验", base.lessons, local.lessons, remote.lessons, item => item.id),
    genreIds: choose("题材选择", base.genreIds, local.genreIds, remote.genreIds),
    genreNotes: choose("题材补充", base.genreNotes, local.genreNotes, remote.genreNotes),
    semanticRetrieval: choose("语义检索授权", Boolean(base.semanticRetrieval), Boolean(local.semanticRetrieval), Boolean(remote.semanticRetrieval))
  }, conflicts };
}
